import React, { Component, useState } from "react";
import { formatoSeparadorMilesValue } from '../../generico/utils/FormatoInput'
import DataTable from 'react-data-table-component';
import PrestamoService from "../../../services/pagos/PrestamoService"
import { trackPromise } from 'react-promise-tracker';
import Popup from "react-popup";
import { DataTableLoading } from "../../generico/DataTableLoading";

const paginationOptions = {
  rangeSeparatorText: "de",
  noRowsPerPage: true
};

export const PrestamoCuota= ({ data }) =>{
  // constructor(props) {
  //   super(props);
  //   this.state = this.getInitialState();

  // }

  const [state, setState] = useState({
    listaPrestamoDetalle: [],
    datosPrestamo: [],
  })
  const [isLoading, setIsLoading] = useState(true)
  // componentDidMount() {
  //   //  this.getListaPrestamoDetalle();
  // }
 const  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });
    const getDetalles = () => {
    var detalle = [];
    var prestamo = [];
    // trackPromise(
      PrestamoService.cuotasPrestamo(data.id, "P")
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          //  console.log(response)
          if (jsonData.codRespuesta === "0") {

            prestamo.push({
              idPrestamo: jsonData.detalleCredito.idPrestamo,
              descripcion: jsonData.detalleCuotas.descripcion,
              idMoneda: jsonData.detalleCuotas.idMoneda,
            })
            for (var i = 0; i < jsonData.detalleCuotas.length; i++) {
              detalle.push({
                id: jsonData.detalleCuotas[i].numeroCuota,
                cuota: jsonData.detalleCuotas[i].numeroCuota,
                vencimiento: jsonData.detalleCuotas[i].vencimiento,
                capital: formatoSeparadorMilesValue(jsonData.detalleCuotas[i].saldoCapital),
                interes: formatoSeparadorMilesValue(jsonData.detalleCuotas[i].interesApagar),
                ivaSinInteres: formatoSeparadorMilesValue(jsonData.detalleCuotas[i].iva),
                seguro: formatoSeparadorMilesValue(jsonData.detalleCuotas[i].seguro),
                ivaSinSeguro: formatoSeparadorMilesValue(jsonData.detalleCuotas[i].vIvaSeguro),
                total: formatoSeparadorMilesValue(jsonData.detalleCuotas[i].montoTotal),
                estado: jsonData.detalleCuotas[i].estadoCuota,
                idPrestamo: jsonData.detalleCredito.idPrestamo,
              })

            }
            //console.log(detalle)
            // this.setState({ datosPrestamo: prestamo, listaPrestamoDetalle: detalle });
            setState({ ...state, listaPrestamoDetalle: detalle });
          }
          else {
            Popup.queue(notifiPopup("Info", jsonData.codDescripcion));
            return;
          }
          setIsLoading(false);
        }
        ).catch(function (error) {
          setIsLoading(false);
          //.authService.logout()
          console.log(error)
        });
    return detalle;
  }


  const getColumnDetalle = () => {
    return [
      {
        name: "Cuota",
        selector: row => row.cuota,
        width: "70px",
      },
      {
        name: "Vencimiento",
        selector: row => row.vencimiento
      },
      {
        name: "Capital",
        selector: row => row.capital,
        width: "130px",
        right: true
      },
      {
        name: "Interés",
        selector: row => row.interes,
        right: true
      },
      {
        name: "IVA s/Int.",
        selector: row => row.ivaSinInteres,
        right: true
      },
      {
        name: "Seguro",
        selector: row => row.seguro,
        right: true
      },
      {
        name: "IVA s/Seguro.",
        selector: row => row.ivaSinSeguro,
        right: true
      },
      {
        name: "Total Cuota",
        selector: row => row.total,
        width: "130px",
        right: true
      },
      {
        name: "Estado",
        selector: row => row.estado,
      }
    ];
  }




    var detalles = state.listaPrestamoDetalle
    if (detalles.length === 0 && data !== undefined)
      getDetalles()
    /*if(this.props.data !== undefined &&  this.props.data.id !== detalles[0].idPrestamo){
      console.log(this.props.data)
      detalles= this.getDetalles()
   
  }*/

    //console.log(this.props.data)
    //console.log(detalles)
    return (
      <DataTable
        noHeader={true}
        pagination={true}
        columns={getColumnDetalle()}
        data={detalles}
        dense={true}
        pagination={true}
        paginationComponentOptions={paginationOptions}
        noDataComponent="SIN DATOS"
        responsive={true}
        striped={true} />

    );
  
}